<template>
  <div>
      <div class="conteudoIcmsIpi">
        <div class="headerIcmsIpi lerMais" @click="ler = !ler">
            <div class="ncmExcessao"><p v-html="_NCMDescIdExcessao.descricao"></p></div> 
            <div  style="font-size:18px; cursor:pointer;font-weight:normal;">
                <span v-if="ler" style="
    font-size: 15px;display: flex;
    align-items: center;
">
                    <img src="/sandboxfront/mapatributario/seta2.svg" alt="" width="18px" :class="{'viraSeta':ler}" style="margin-left:6px">
                </span>
                <span v-else  style="
    font-size: 15px;display: flex;
    align-items: center;
">
                     <img src="/sandboxfront/mapatributario/seta2.svg" alt="" width="18px" style="margin-left:6px" >
                </span>
            </div>
        </div>
        <div class="conteudoGeralEx" v-show="ler">
            <div class="geralIcmsIpi">
                ICMS/IPI
            </div>
            <div class="espacamento"> 
                <span class="txtBo">Alíquota ICMS: </span> <span>{{_NCMDescIdExcessao.aliquotas}}%</span>
            </div>
            <div class="espacamento"> 
                <span class="txtBo">IPI: </span> <span>{{_NCMDescIdExcessao.ipi}}</span>
            </div>
            <div class="geralIcmsIpi">
                PIS/COFINS
            </div>
            <div class="espacamento">
                 <span class="txtBo">PIS/COFINS </span><br> <span v-html="_NCMDescIdExcessao.cst"></span>
                 </div>
            <div class="espacamento"> 
                
                <div v-html="_NCMDescIdExcessao.piscofins">

                </div>               
                
            </div>
           
        </div>
        </div>
  </div>
</template>

<script>

export default {
    props:['_NCMDescIdExcessao'],
    data(){
        return{
            ler:false,
        }
    }
}
</script>

<style>
.ex{
    background: #4A154B;
}
.geralIcmsIpi{
    background: #4A154B;
    width: 100%;
    height: 48px;  
padding-right: 30px;
    color: #fff;
    font-size: 20px;
    font-weight: 600;
    border-radius: 0px 0px 0px 0px;
    padding-left: 30px; 
    display: flex;    
    align-items: center;
    margin-top: 3px;
}
.lerMais{
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.ncmExcessao{
font-size: 15px;
width: 100%;
display: flex;
padding: 10px;
}

.ncmExcessao > p{
width: 100%;
text-align: start;
}
</style>